export default "__VITE_ASSET__c563a14c__"